import { render, staticRenderFns } from "./SettingsSize.vue?vue&type=template&id=3aa16df6&"
import script from "./SettingsSize.vue?vue&type=script&lang=js&"
export * from "./SettingsSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports